(function ($) {
    'use strict';
    class SearchAjax {
        constructor() {
            this.$form = $('form[name="main-search"]');
            this.tabsSelected = 0;  // 0 All, 1 Products, 2 Pages 
            this.hasClickPagnate = false;
            this.isFirstLoad = false;
            this.bindEvent();
            this.initRequest();
        }
        /**
         * 初始化，判断url有没有q参数,有的话就请求
         * @returns 
         */
        initRequest() {
            var q = this.getQueryString('q');
            var type = this.getQueryString('type');
            var allAllowTypes = ['product,page,article', 'product', 'page,article'];
            if (!q) {
                return;
            }
            if (!type || !allAllowTypes.includes(type)) {
                type = 'product,page,article';
            }
            $('.search-result-new').removeClass('d-none-important');
            $('.search-tabs').removeClass('d-none-important').addClass('d-flex');
            switch (type) {
                case 'product,page,article':
                    // 切换tab
                    this.tabsSelected = 0;
                    $('.search-tabs .tabs-item').eq(0).addClass('active').siblings().removeClass('active');
                    break;
                case 'product':
                    // 切换tab
                    this.tabsSelected = 1;
                    $('.search-tabs .tabs-item').eq(1).addClass('active').siblings().removeClass('active');
                    $('.search-result-new').removeClass('showPages').addClass('showProducts');
                    break;
                case 'page,article':
                    // 切换tab
                    this.tabsSelected = 2;
                    $('.search-tabs .tabs-item').eq(2).addClass('active').siblings().removeClass('active');
                    $('.search-result-new').addClass('showPages').removeClass('showProducts');
                    break;
                default:
                    break;
            }
            this.isFirstLoad = true;
            this.searchProductAndPages();
        }
        /**
         * 获取url参数
         * @param {*} name 
         * @returns 
         */
        getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
        /**
         * 绑定事件
         */
        bindEvent() {
            // 输入框输入
            $('body').on('input', '.top-content input[type="search"]', theme.debounce((e) => {
                e.preventDefault();
                this.searchProductAndPages();
            }, 500));
            // 输入框输入
            $('body').on('keydown', '.top-content input[type="search"]', (e) => {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    this.searchProductAndPages();
                }
            });
            // 点击搜索图标
            $('.icon-search').click((e) => {
                e.preventDefault();
                this.searchProductAndPages();
            });
            // 点击tab切换
            $('.search-tabs').on('click', '.tabs-item', (e) => {
                e.preventDefault();
                var $target = $(e.target);
                $target.addClass('active').siblings().removeClass('active');
                var index = $target.index();
                if (index == this.tabsSelected) {
                    return;
                }
                this.tabsSelected = index;
                this.handleTabsClick();
                // 切到all的时候，如果已经切过分页，则需要重新刷新
                if (index == 0 && this.hasClickPagnate) {
                    this.searchProductAndPages();
                }
            })
            // 监听翻页
            $('.search-result-new').on('click', 'a.pagination__item', (e) => {
                e.preventDefault();
                var href = $(e.target).attr('href');
                var searchParam = href.split('?')[1];
                this.hasClickPagnate = true;
                if (this.tabsSelected == 1) {
                    this.getProductContent(searchParam)
                } else if (this.tabsSelected == 2) {
                    this.getPagesContent(searchParam);
                }
            });
            // 点击View all
            $('.search-result-new').on('click', '.search__view-all a', (e) => {
                e.preventDefault();
                var $targetParent = $(e.target).parent();
                var index = 0;
                if ($targetParent.hasClass('product')) {
                    index = 1;
                    this.tabsSelected = 1;
                } else if ($targetParent.hasClass('pages')) {
                    index = 2;
                    this.tabsSelected = 2;
                }
                $('.search-tabs .tabs-item').eq(index).addClass('active').siblings().removeClass('active');
                this.handleTabsClick();
            });
        }
        /**
         * tab切换时做的DOM操作
         */
        handleTabsClick() {
            switch (this.tabsSelected) {
                case 0: {
                    $('.search-result-new').removeClass('showPages').removeClass('showProducts');
                    var $productItems = $('.product-item'),
                        $pageItems = $('.page-item');
                    // 点all的时候隐藏部分product，只展示8个
                    $productItems.map((index, item) => {
                        if (index > 7) {
                            $(item).hide();
                        }
                    });
                    // 点all的时候隐藏部分pages，只展示4个
                    $pageItems.map((index, item) => {
                        if (index > 3) {
                            $(item).hide();
                        }
                    });
                    if ($productItems.length == 0 && $pageItems.length == 0) {
                        $('.search__empty.all').removeClass('d-none-important');
                        $('.search-content').addClass('d-none-important');
                    }
                    else if ($productItems.length == 0) {
                        $('.search__empty.all').addClass('d-none-important');
                        $('.search-content').eq(0).addClass('d-none-important').eq(1).removeClass('d-none-important');
                    } else if ($pageItems.length == 0) {
                        $('.search__empty.all').addClass('d-none-important');
                        $('.search-content').eq(0).removeClass('d-none-important').eq(1).addClass('d-none-important');
                    }
                    break;
                }
                case 1: {
                    $('.search-result-new').removeClass('showPages').addClass('showProducts');
                    $('.product-item').show();
                    $('.search__empty.all').addClass('d-none-important');
                    $('.search-content').removeClass('d-none-important');
                    break;
                }
                case 2: {
                    $('.search-result-new').removeClass('showProducts').addClass('showPages');
                    $('.page-item').show();
                    $('.search__empty.all').addClass('d-none-important');
                    $('.search-content').removeClass('d-none-important');
                    break;
                }
                default:
                    break;
            }
        }
        /**
         * 获取product和pages
         */
        searchProductAndPages() {
            const q = $(".top-content #Search").val().trim();
            if (q == '') {
                return;
            }
            const serializeData = this.$form.serialize(); // 序列化后的数据
            const replaceStr = 'type=product%2Cpage%2Carticle'; // 需要替换的数据
            const searchParam1 = serializeData.replace(replaceStr, 'type=product');  // product
            const searchParam2 = serializeData.replace(replaceStr, 'type=page%2Carticle');  // pages & blogs
            $('.search-result-new').removeClass('d-none-important');
            $('.search-tabs').removeClass('d-none-important').addClass('d-flex');
            $('.search__empty').addClass('d-none-important');
            Promise.all([
                this.getProductContent(searchParam1),
                this.getPagesContent(searchParam2)
            ]).then(res => {
                this.hasClickPagnate = false;
                this.isFirstLoad = false;
                this.handleTabsClick();
            });
        }
        /**
         * 获取product
         * @param {*} searchParam 
         * @returns 
         */
        getProductContent(searchParam) {
            return new Promise((resolve, reject) => {
                !this.isFirstLoad && theme.Preloader.set($('.search-product'));
                this.requestContent(searchParam, 1).then(res => {
                    $('.search-product').html(res);
                    console.log(res, "res")
                    !this.isFirstLoad && theme.Preloader.unset($('.search-product'));
                    $('.search-product').parent().removeClass('d-none-important');
                    resolve();
                });
            })
        }
        /**
         * 获取pages
         * @param {*} callBack 
         */
        getPagesContent(searchParam) {
            return new Promise((resolve, reject) => {
                !this.isFirstLoad && theme.Preloader.set($('.search-pageblogs'));
                this.requestContent(searchParam, 2).then(res => {
                    $('.search-pageblogs').html(res);
                    !this.isFirstLoad && theme.Preloader.unset($('.search-pageblogs'));
                    $('.search-pageblogs').parent().removeClass('d-none-important');
                    resolve();
                })
            })
        }
        /**
          * 封装请求接口
          * @param {*} searchParam 搜索参数
          * @param {*} searchType 搜索类型，1是product，2是pages
          * @returns 
          */
        requestContent(searchParam, searchType) {
            return new Promise((reslove, reject) => {
                $.get(`${Shopify.routes.root}search?${searchParam}`).done(function (response) {
                    var $content = $(response);
                    var html = $content.find(searchType == 1 ? '.search-product' : '.search-pageblogs').html();
                    reslove(html);
                }).fail(function () {
                    reslove('');
                })
            })
        }
    }
    theme.AssetsLoader.onPageLoaded(function () {
        theme.SearchAjax = new SearchAjax;
    });
})(jQueryTheme);